import { delay, put, takeEvery, call, select, takeLatest } from 'redux-saga/effects';
import { RequestPutScriptAction, RequestScriptListAction } from 'redux/actions/type';
import {
  REQUEST_PUT_SCRIPT,
  REQUEST_SCRIPT_LIST,
  REQUEST_SCRIPT_LIST_BY_SCROLL,
} from 'redux/actions/types';
import { getAPI, putAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import { API } from 'commons/constants/KeyFlowAPI';
import { SPECIAL_CHARACTER_ERROR } from 'commons/constants/KeyFlowMessage';
import {
  requestScriptListByScrollFailure,
  requestScriptListByScrollSuccess,
  requestScriptListFailure,
  requestScriptListSuccess,
  requestPutScriptSuccess,
  requestPutScriptFailure,
  requestPutScript,
  throwError,
  requestScriptList,
} from 'redux/actions/actions';
import ScriptVO from 'commons/vo/Script';
import { PaginationType } from 'commons/framework/type';
import ScriptParamVO from 'commons/vo/param/ScriptParamVO';
import { isContainSpecialCharacter } from 'commons/utils/commonUtil';
import KeyFlowError from 'commons/framework/KeyFlowError';
import { AxiosResponse } from 'axios';

function* requestScriptListSaga(action: RequestScriptListAction) {
  try {
    const { param }: { param: ScriptParamVO } = action.payload;
    if (isContainSpecialCharacter(param.keyword)) {
      throw new KeyFlowError(SPECIAL_CHARACTER_ERROR);
    }
    const response: AxiosResponse = yield call(getAPI, API.SCRIPT, param);

    const keyFlowResponse = new KeyFlowResponse(response.data);
    const resultList: ScriptVO[] = keyFlowResponse.getResult(ScriptVO) as ScriptVO[];
    const pagination: PaginationType = keyFlowResponse.page;
    const keyword = (param as ScriptParamVO).keyword || '';

    if (action.type === REQUEST_SCRIPT_LIST) {
      yield put(requestScriptListSuccess({ scriptList: resultList, pagination, keyword }));
    } else {
      yield put(requestScriptListByScrollSuccess({ scriptList: resultList, pagination }));
    }
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    if (action.type === REQUEST_SCRIPT_LIST) {
      yield put(requestScriptListFailure());
    } else {
      yield put(requestScriptListByScrollFailure());
    }
  }
}
function* requestPutScriptSaga(action: RequestPutScriptAction) {
  try {
    const { param } = action.payload;
    const response: AxiosResponse = yield call(putAPI, API.SCRIPT, param);
    // payload에서 data를 빼고 보내기
    const script: ScriptVO = response.data as ScriptVO;
    yield put(requestPutScriptSuccess({ script }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestPutScriptFailure());
  }
}

export function* watchScriptSaga() {
  yield takeLatest(REQUEST_SCRIPT_LIST, requestScriptListSaga);
  yield takeLatest(REQUEST_SCRIPT_LIST_BY_SCROLL, requestScriptListSaga);
  yield takeLatest(REQUEST_PUT_SCRIPT, requestPutScriptSaga);
}
